import { gql } from "apollo-angular";

export default gql`
  query CompaniesWithAccountSelect(
    $list: CompaniesList!
    $filter: CompaniesFilter!
  ) {
    companies(list: $list, filter: $filter) {
      metaData {
        count
      }
      objects {
        id
        name
        status
        account {
          id
          name
        }
      }
    }
  }
`;
